<template>
    <div>
        <modal :title="title" :html="text"/>
    </div>
</template>

<script>
    import Modal from "../components/Modal"

    export default {
        name: 'consumption-info',
        components: {Modal},
        data () {
            return {
                title: `Informazioni sui costi`,
                text: `
                <p>Il dato da inserire è ricavabile dalle bollette energetiche.</p>
                <p>Sono possibili 2 opzioni: si può inserire il costo [€] mensile pagato mediamente dall'utenza in bolletta o inalternativa il costo complessivo annuale.</p>
                <p>a) opzione costo mensile: è il valore dell'imponibile [no IVA] pagato mediamente mensilmente</p>
                <p>b) opzione costo annuale: è il valore dell'imponibile [no IVA] pagato annualmente. E' la somma di tutti i  costi mensili.</p>
                <p>Si consiglia di inserire l'opzione costo annuale se si hanno costi mensili in bolletta molto differenti tra loro (ad esempio se ci sono rettifiche o ricalcoli dovuti a consumi stimati).</p>
                `
            }
        }
    };
</script>